/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';
import { ChipsDefaultOptions } from '../types/chip-base.type';

/** Injection token to be used to override the default options for the chips module. */
export const CHIPS_DEFAULT_OPTIONS = new InjectionToken<ChipsDefaultOptions>('chips-default-options', {
  providedIn: 'root',
  factory: () => ({
    separatorKeys: ['Enter', ','],
  }),
});

/**
 * Injection token that can be used to reference instances of `ChipRemove`. It serves as
 * alternative token to the actual `ChipRemove` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const CHIP_REMOVE = new InjectionToken('ChipRemove');

/**
 * Injection token used to avoid a circular dependency between the `Chip` and `ChipAction`.
 */
export const CHIP = new InjectionToken('Chip');
